
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/[...blog]",
      function () {
        return require("private-next-pages/severalbrands/[...blog].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/severalbrands/[...blog]"])
      });
    }
  